

<template>
  <component :is="comp" />
</template>

<script lang="ts" setup>
import { defineAsyncComponent, markRaw, ref, defineProps, watch } from "vue";

const props = defineProps<{
  version?: string;
}>();

const comp = ref(null);

function loadComponent(version?: string) {
  return defineAsyncComponent(() =>
    import(`./${version ?? "v1.0.0"}/DocView.vue`)
      .then((mod) => mod.default)
      .catch(() =>
        import("./v1.0.0/DocView.vue").then((mod: any) => mod.default)
      )
  );
}

watch(
  () => props.version,
  (newVersion) => {
    comp.value = markRaw(loadComponent(newVersion));
  },
  { immediate: true }
);

// 申明name
</script>
